var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Store, Actions, ofActionDispatched, Select } from '@ngxs/store';
import { ResetPasswordSuccess, ResetPassword, ResetPasswordFailure } from '../../state/auth/auth.actions';
import { AuthState } from '../../state/auth/auth.state';
import { Observable, Subject } from 'rxjs';
import { MatSnackBar } from '@angular/material';
import { takeUntil } from 'rxjs/operators';
var ResetPageComponent = /** @class */ (function () {
    function ResetPageComponent(formBuilder, store, actions, snackbar) {
        this.formBuilder = formBuilder;
        this.store = store;
        this.actions = actions;
        this.snackbar = snackbar;
        this.view = 'reset';
        this.ngUnsubscribe = new Subject();
        var profileCheck = this.store.selectSnapshot(AuthState.getProfileCheck);
        var email = profileCheck ? profileCheck.email : '';
        this.form = this.formBuilder.group({
            'email': [email, Validators.email]
        });
    }
    ResetPageComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.actions
            .pipe(ofActionDispatched(ResetPasswordSuccess), takeUntil(this.ngUnsubscribe))
            .subscribe(function (action) {
            _this.handleResetSuccess(action.email);
        });
        this.actions
            .pipe(ofActionDispatched(ResetPasswordFailure), takeUntil(this.ngUnsubscribe))
            .subscribe(function () {
            _this.handleResetFailure();
        });
    };
    ResetPageComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    ResetPageComponent.prototype.handleSubmit = function () {
        if (this.form.valid) {
            var email = this.form.get('email').value;
            this.store.dispatch(new ResetPassword(email));
        }
    };
    ResetPageComponent.prototype.handleResetSuccess = function (email) {
        this.email = email;
        this.view = 'success';
    };
    ResetPageComponent.prototype.handleResetFailure = function () {
        this.snackbar.open('There was an error resetting your password.');
    };
    __decorate([
        Select(AuthState.getLoading),
        __metadata("design:type", Observable)
    ], ResetPageComponent.prototype, "loading$", void 0);
    return ResetPageComponent;
}());
export { ResetPageComponent };
